export default __webpack_public_path__ + "static/media/Logo_210430_3.3f9ffdde.jpg";